
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'SearchForm',
  data() {
    return {
      search: '',
    };
  },
  methods: {
    ...mapActions(['index']),
    searchPokemon() {
      const query = `?q=name:*${this.search}*`;
      this.index(query);
    },
  },
});
